export default "/react/logoTextMark-dd85a1ca.png";